export default function isTooOld(age: number, maxAge: number): boolean {
	return maxAge <= age;
}
